import { PerkDefinition } from "./types";

export const perkLifesteal = {
  id: "perk_lifesteal",
  name: "Lifesteal",
  description: "Heals for 50% of damage dealt (stacks).",
  apply: () => {
    // Lifesteal is applied during combat, not at initialization
  },
  onDamageDealt: (totalDamage, { stackCount, applyHeal }) => {
    // Heal for 50% of damage dealt, multiplied by stack count
    const healAmount = Math.floor(totalDamage * 0.5 * stackCount);
    if (healAmount > 0) {
      return applyHeal(healAmount);
    }
    return 0;
  },
} satisfies PerkDefinition<"perk_lifesteal">;
